// lib/Factbox/lib/consume.ts
var e = async ({ input: e }) => {
	if (Array.isArray(e)) throw Error("Factbox plugin expected string for consumation, not a list/array");
	if (typeof e.data != "string") throw Error("Factbox plugin expected string for consumation");
	return t(e);
}, t = (e) => {
	let { text: t, title: n, created: r, modified: i, id: a, original_version: o, original_updated: s, locally_changed: c } = JSON.parse(e.data), l = {
		type: "core/factbox/body",
		class: "block",
		children: t.split("\n").map((e) => ({
			type: "core/text",
			class: "text",
			children: [{ text: e }]
		}))
	};
	return {
		...e,
		data: {
			id: crypto.randomUUID(),
			class: "block",
			type: "core/factbox",
			properties: {
				title: n,
				text: t,
				created: r,
				modified: i,
				id: a,
				original_id: a,
				original_updated: s,
				original_version: o,
				locally_changed: c,
				rel: "factbox",
				type: "core/factbox"
			},
			children: [{
				type: "core/factbox/title",
				class: "text",
				children: [{ text: n }]
			}, l]
		}
	};
};
export { e as consume };
